import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { createPortal } from 'react-dom'

export const ImagePreview = ({ children, src }: { children: React.ReactNode; src: string }) => {
  const [open, setOpen] = useState(false)

  // ESC zatvaranje
  useEffect(() => {
    if (!open) return

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false)
    }

    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open])

  return (
    <>
      <div style={{ cursor: 'zoom-in' }} onClick={() => setOpen(true)}>
        {children}
      </div>

      {open &&
        createPortal(
          <Overlay onClick={() => setOpen(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <Close onClick={() => setOpen(false)}>×</Close>
              <FullImage src={src} />
            </ModalContent>
          </Overlay>,
          document.body,
        )}
    </>
  )
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

const ModalContent = styled.div`
  position: relative;
  max-width: 90%;
  max-height: 90%;
`

const FullImage = styled.img`
  max-width: 100%;
  max-height: 90vh;
  border-radius: 12px;
`

const Close = styled.button`
  position: absolute;
  top: -12px;
  right: -12px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: white;
  cursor: pointer;
  font-size: 20px;
`
